import { GetterTree, MutationTree, ActionTree, Module } from 'vuex';
import { NotificationState, RootState } from '@/types';
import uuidv4 from 'uuid/v4';
import NotificationBannerService from '@/services/notification.banner.service';

type NotificationGetter = GetterTree<NotificationState, RootState>;

export const initialState = (): NotificationState => {
  return {
    initialState,
    toastErrorMessages: {},
    dismissedBanners: [],
    notificationBanner: null,
  };
};

export const getters: NotificationGetter = {
  notifications: (state) => state,
  toastErrorMessages: (state) => state.toastErrorMessages,
  toastErrorMessage: (state, key) => state.toastErrorMessages[key],
  notificationBanner: (state) => state.notificationBanner,
  dismissedBanners: (state) => state.dismissedBanners,
};

export const mutations: MutationTree<NotificationState> = {
  addToastErrorMessage(state, msg) {
    const messages: {[id: string]: string} = {};
    Object.assign(messages, state.toastErrorMessages);
    messages[msg.key] = msg.message;
    state.toastErrorMessages = messages;
  },
  removeToastErrorMessage(state, key) {
    delete state.toastErrorMessages[key];
  },
  clearToastErrorMessages(state) {
    state.toastErrorMessages = {};
  },
  showNotificationBanner(state, banner) {
    if (!banner) {
      state.notificationBanner = null;
      return;
    }
    state.notificationBanner = banner;
  },
  dismissNotificationBanner(state, bannerId) {
    state.dismissedBanners.push(bannerId);
  },
  clearActiveNotificationBanner(state, bannerId) {
    state.notificationBanner = null;
  },
};

export const actions: ActionTree<NotificationState, RootState> = {
  addToastErrorMessage(context, message) {
    const key: string = uuidv4();
    if (message === 'canceled') {
      return;
    }
    context.commit('addToastErrorMessage', {key, message});
    return key;
  },
  clearToastErrorMessages(context, message) {
    context.commit('clearToastErrorMessages', message);
  },
  async retrieveActiveNotificationBanner(context) {
    const banner = await NotificationBannerService.getCurrentNotificationBanner();
    if (!(banner as any).errorCode) {
      context.commit('showNotificationBanner', banner);
      return banner;
    }
    context.commit('showNotificationBanner', null);
  },
};

export const notifications: Module<NotificationState, RootState> = {
  state: initialState(),
  getters,
  mutations,
  actions,
};
